import { noop } from 'lodash';
import { serverSide } from './environment';

const proxyHandler = handledMethods => ({
  get: (target, prop) => handledMethods[prop.toString()] || noop
});

export const withServerSideProxy = (target, handler) => serverSide ? new Proxy(target, proxyHandler(handler)) : target;